import { isAccessible } from '../calculated/is-accessible';
export var shouldRenderSchema = function (item) {
    if (item === void 0) { item = {}; }
    return (item.challenge || false) && isAccessible(item);
};
